import React, { useReducer, Fragment, useEffect, useState } from "react";
import {
  defaultStateEntity,
  initializeCustodianEntity,
  CustodianEntityReducer,
  ValidateClearingHouse,
} from "./reducer";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Input,
  Button,
  Table,
  Label,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import style from "./CustodianEntity.module.scss";
import CircularProgress from "../../CircularProgress/CircularProgress";
import { Field, Combobox } from "../Order/Field/Field";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import classnames from "classnames";
import ModalConfirm from "../../Asset/Modals/ModalConfirm";
import { CustodianEntityStatus } from "../../../utils/Helper";

const CustodianEntityClearingHouse = ({ openClearingHouse, toggle, fetchs, ...props }) => {
  const [state, dispatch] = useReducer(
    CustodianEntityReducer,
    defaultStateEntity(),
    initializeCustodianEntity(props)
  );
  const [modal, setModal] = useState({ open: false, indexContact: 0 });
  const { errors, custodianClearingHouse, custodian } = state;
  useEffect(() => {
    props.callApi("GetClearingHouses", {}).then((response) => {
      dispatch({
        type: "SET_CUSTODIAN_CLEARING_HOUSE",
        response,
      });
    });
  }, []);

  const confirmClearingHouse = () => {
    const errors = ValidateClearingHouse(state);
    if (errors == false) {
      dispatch({ type: "UPDATE_VALIDATION_CONTACT_FORM", errors });
      if (props.EditClearingHouse) {
        props.updateClearingHouse({ custodianClearingHouse });
        props.onChangeUpdate({
          EditClearingHouse: false,
        });
      } else {
        props.setClearingHouse({ custodianClearingHouse });
      }
      dispatch({ type: "RESET_CLEARING_HOUSE" });
      props.onChangeUpdate({
        openCustodianEntityClearingHouse: false,
      });
    } else {
      dispatch({ type: "UPDATE_VALIDATION_CONTACT_FORM", errors });
    }
  };
  const onChangeClearingHouse = (fields) => dispatch({ type: "SET_CLEARING_HOUSE", fields });

  const ClickEditClearingHouses = (e, index) => {
    props.onChangeUpdate({
      EditClearingHouse: true,
      IndexEditClearingHouse: index,
    });
    dispatch({ type: "GET_CLEARING_HOUSE", e });
    props.onChangeUpdate({
      openCustodianEntityClearingHouse: true,
    });
  };

  const cancelClearingHouse = () => {
    dispatch({ type: "RESET_CLEARING_HOUSE" });
    props.onChangeUpdate({
      EditClearingHouse: false,
      openCustodianEntityClearingHouse: false,
    });
  };

  const ClickDeleteClearingHouse = (e, index) => {
    setModal({ ...modal, open: true, indexContact: index });
  };

  const toggleModal = (name, props = {}) => {
    setModal({ ...modal, open: false });
  };

  const onConfirm = (name) => {
    props.deleteClearingHouse(modal.indexContact);
  };

  return (
    <div>
      <ModalConfirm
        open={modal.open}
        title={"Delete Clearing House"}
        message={"Are you sure you want to delete Custodian Entity Clearing House?"}
        toggle={() => toggleModal("confirm", {})}
        onConfirm={() => onConfirm()}
      />
      {openClearingHouse ? (
        <div className={style.edit}>
          <Row>
            <Col lg={6} xs={12}>
              <Field label={"Clearing House Code"} error={errors.CustodyClearingHouseCode}>
                <Input
                  type={"text"}
                  placeholder={"Clearing House Code"}
                  value={custodianClearingHouse.CustodyClearingHouseCode || ""}
                  invalid={errors.CustodyClearingHouseCode}
                  disabled={
                    custodianClearingHouse.CustodianEntityClearingHouseStatus == "Blocked" ||
                    custodianClearingHouse.CustodianEntityClearingHouseStatus == "Inactive"
                  }
                  onChange={(e) =>
                    onChangeClearingHouse({
                      CustodyClearingHouseCode: e.target.value,
                    })
                  }
                />
              </Field>
            </Col>
            <Col lg={6} xs={12}>
              <Field label={"Clearing House Name"}>
                <Combobox
                  disabled={custodianClearingHouse.CustodianEntityClearingHouseStatus == "Inactive"}
                  style={{ background: "#edf9ff", fontWeight: 500 }}
                  value={custodianClearingHouse.ClearingHouseId}
                  onChange={(v) => onChangeClearingHouse({ ClearingHouseId: v })}
                  items={Object.values(custodianClearingHouse.clearingHouseNames).map((key, index) => ({
                    id: key.id,
                    description: key.name,
                  }))}
                />
              </Field>
            </Col>
          </Row>
          <Row>
            <Col lg={6} xs={12} style={{ display: "grid", alignItems: "center", left: "20px" }}>
              <Label check>
                <Input
                  disabled={custodianClearingHouse.CustodianEntityClearingHouseStatus == "Inactive"}
                  type="checkbox"
                  checked={custodianClearingHouse.CustodyClearingHouseIsDefault}
                  value={custodianClearingHouse.CustodyClearingHouseIsDefault}
                  onClick={(e) =>
                    onChangeClearingHouse({
                      CustodyClearingHouseIsDefault: !custodianClearingHouse.CustodyClearingHouseIsDefault,
                    })
                  }
                />{" "}
                Is default clearing house?
              </Label>
            </Col>
            <Col lg={6} xs={12}>
              <Field label={"Clearing House Status"}>
                <Combobox
                  style={{ background: "#edf9ff", fontWeight: 500 }}
                  value={custodianClearingHouse.CustodianEntityClearingHouseStatus}
                  onChange={(v) =>
                    onChangeClearingHouse({
                      CustodianEntityClearingHouseStatus: v,
                    })
                  }
                  items={Object.values(CustodianEntityStatus).map((key, index) => ({
                    id: key.id,
                    description: key.name,
                  }))}
                />
              </Field>
            </Col>
          </Row>
          <Row>
            <Col>
              <Field
                label={"Settlement Instructions"}
                // error={errors.CustodyClearingHouseSettlementInstructions}
              >
                <Input
                  disabled={custodianClearingHouse.CustodianEntityClearingHouseStatus == "Inactive"}
                  type={"textarea"}
                  placeholder={"Settlement Instructions"}
                  value={custodianClearingHouse.CustodyClearingHouseSettlementInstructions}
                  //invalid={errors.CustodyClearingHouseSettlementInstructions}
                  onChange={(e) =>
                    onChangeClearingHouse({
                      CustodyClearingHouseSettlementInstructions: e.target.value,
                    })
                  }
                />
              </Field>
            </Col>
          </Row>
          <div className={style.actions}>
            <Button className={"btn-sm"} color="light" onClick={(e) => cancelClearingHouse()}>
              {true ? "Cancel" : "Close"}
            </Button>{" "}
            <LaddaButton
              className={classnames("btn-sm btn-ladda btn-primary")}
              //loading={buttons.confirm.loading}
              onClick={() => confirmClearingHouse()}
              data-style={EXPAND_RIGHT}
            >
              {props.EditClearingHouse ? "Edit" : "Save"}
            </LaddaButton>
          </div>
        </div>
      ) : (
        <Fragment>
          <div className={`${style.table}`}>
            <Table responsive striped>
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Def.</th>
                  <th>Status</th>
                  <th style={{ width: "1px" }}>Edit</th>
                  <th style={{ width: "1px" }}>Del.</th>
                </tr>
              </thead>
              {props.clearingHouses.length == 0 ? (
                <tbody>
                  <EmptyClearingHouses />
                </tbody>
              ) : (
                <tbody>
                  {props.clearingHouses.map((c, index) => (
                    <React.Fragment>
                      {c.CustodyClearingHouseChangeType !== "Delete" && (
                        <tr style={{ textAlign: "end" }}>
                          <td>{c.CustodyClearingHouseCode}</td>
                          <td>{c.CustodyClearingHouseIsDefault == true ? "true" : "false"}</td>
                          <td>{c.CustodianEntityClearingHouseStatus}</td>
                          <td onClick={() => ClickEditClearingHouses(c, index)}>
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                          </td>
                          {c.CustodianEntityClearingHouseStatus == "Blocked" ||
                          c.CustodianEntityClearingHouseStatus == "Inactive" ? (
                            <td></td>
                          ) : (
                            <td onClick={() => ClickDeleteClearingHouse(c, index)}>
                              <i class="fa fa-close" aria-hidden="true"></i>
                            </td>
                          )}
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              )}
            </Table>
          </div>
        </Fragment>
      )}
    </div>
  );
};

const EmptyClearingHouses = () => (
  <tr className={style.empty}>
    <td colSpan="4">
      <h5 style={{ textAlign: "center" }}>No Clearing Houses</h5>
    </td>
  </tr>
);

export function validationsClearingHouse() {
  return {
    CustodyClearingHouseCode: { empty: true },
  };
}

export default CustodianEntityClearingHouse;
